import { render, staticRenderFns } from "./roleEmpowerment.vue?vue&type=template&id=d6269c68&scoped=true&"
import script from "./roleEmpowerment.vue?vue&type=script&lang=js&"
export * from "./roleEmpowerment.vue?vue&type=script&lang=js&"
import style0 from "./roleEmpowerment.vue?vue&type=style&index=0&id=d6269c68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6269c68",
  null
  
)

export default component.exports